import { vec3 } from 'gl-matrix'
import Camera from 'nanogl-camera'

import { ICameraController } from '@/webgl/cameras/ICameraController'
import { PlayerEntity } from '@/webgl/runner/entities/PlayerEntity'
import GameWorld from '@/webgl/runner/GameWorld'

export default class RunnerCamera implements ICameraController {
  world: GameWorld
  camera: Camera

  public height: number = 0.5

  get player(): PlayerEntity {
    return this.world.player
  }

  constructor(world: GameWorld) {
    this.world = world
  }

  start(camera: Camera): void {
    this.camera = camera
    this.camera.position.set(this.world.player.node.position)
    this.camera.lookAt(vec3.fromValues(0, 0, -this.world.settings.LANE_LENGTH))
    this.camera.invalidate()
  }

  stop(): void {}

  setPosition(position: vec3) {
    this.camera.position.set(position)
    this.camera.invalidate()
  }

  update(dt: number): void {
    this.camera.lookAt(vec3.fromValues(this.camera.x, 0, -this.world.settings.LANE_LENGTH * 0.85))

    if (this.player.node._hasInvalidWorldMatrix(true)) {
      this.camera.x = this.player.node.x
      this.camera.y = this.player.node.y
      this.camera.z = this.player.node.z
    }
  }
}
